import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ivory px-5 py-10" data-id="element-94" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-2xl text-center" data-id="element-95" data-mp="3gfsoch60l2p3">
        <p className="font-serif-display text-base font-bold text-navy" data-id="element-96" data-mp="3ghc3u5juj9pt">
          THE YOUNG INVENTOR LAB™
        </p>
        <p className="mt-2 text-xs leading-relaxed text-navy/60" data-id="element-97" data-mp="36pfshssr1n3n">
          Printable STEM build library for curious kids ages 5–12.
        </p>
        <p className="mt-4 text-xs leading-relaxed text-navy/50" data-id="element-98" data-mp="3ug3fllb8kjas">
          Digital product · No physical kit shipped
          <br data-id="element-99" data-mp="387fbm8yvbf9" />
          One-time payment · No subscription
          <br data-id="element-100" data-mp="3levk1b03twke" />
          For personal, home, and single-classroom use. Redistribution or resale is not permitted.
        </p>
        <p className="mt-4 text-xs leading-relaxed text-navy/45" data-id="element-101" data-mp="3qc3zv4xs5oih">
          Every build card includes a safety note. Adult supervision is recommended wherever it is
          indicated.
        </p>
        <p className="mt-4 text-xs text-navy/45" data-id="element-102" data-mp="2ez1iw8rrqwxs">
          © 2026 The Young Inventor Lab™. All rights reserved.
        </p>
      </div>
    </footer>;
}